const headers = {
  'secret-key': '6-VUdzeFZooiU_wJNVho',
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

export default function fetcher(path, method) {
  method = method || 'GET';
  return fetch(path, { headers: headers, method: method}).then(res => res.json());
}